import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FormataDataHelper {

    constructor() { }

    formatarData(date: Date): string {
        const d = new Date(date);
        const month = '' + (d.getMonth() + 1);
        const day = '' + d.getDate();
        const year = d.getFullYear();

        return [day.padStart(2, '0'), month.padStart(2, '0'), year].join('-');
    }

    static formatarCompetencia(pa: number | undefined): string {
        if (!pa) return '-';
        const year = Math.floor(pa / 100);
        const month = pa % 100;
        const meses = ['01', '02', '03', '04', '05', '06',
                       '07', '08', '09', '10', '11', '12'];
        return `${meses[month - 1]}/${String(year)}`;
      }
}